import { useLayoutEffect } from 'react';
import { WordsetContextProvider } from '@/contexts/WordSetContext/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

export default function WordSet(
  props: StackScreenProps<TherapistStackParamList, 'WordSet'>,
) {
  useLayoutEffect(() => {
    if (props.route.params.templateMode === 'create') {
      props.navigation.setOptions({
        title: 'Set als Vorlage speichern',
        headerTitleAllowFontScaling: false,
      });
    } else if (props.route.params.templateMode === 'update') {
      props.navigation.setOptions({
        title: 'Vorlage bearbeiten',
        headerTitleAllowFontScaling: false,
      });
    }
  }, [props.navigation, props.route.params]);

  return (
    <WordsetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
      fromTemplate={props.route?.params?.fromTemplate}
    >
      <SetsSelectedWrapper props={props} />
    </WordsetContextProvider>
  );
}
